
import { useDispatch, useSelector } from "react-redux";
import { Box, TextField } from "@mui/material";
import MaterialTable from "material-table"
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { AddLeavingReasonAction, UpdateLeavingReasonAction, DeleteLeavingReasonAction } from "../../../../../store/Ancillary/LeavingReason/Action";

const LeavingReason = () => {
    const dispatch = useDispatch()
    const { leavingreasonData } = useSelector(state => state?.AncillaryReducer?.LeavingReasonReducer);

    return (
        <Box>
            <MaterialTable
                columns={[
                    {
                        title: "Leaving Reason", cellStyle: { padding: "0px 10px" }, field: "lreason_name", validate: rowData => rowData?.lreason_name === '' || rowData?.lreason_name === undefined ? 'Leaving Reason cannot be empty' : '',
                        editComponent: props => (
                            <TextField
                                required={true}
                                variant="standard"
                                value={props?.value}
                                onChange={e => props.onChange(e.target.value)}
                                error={props?.error}
                                helperText={props?.helperText}
                            />
                        )
                    },
                ]}
                data={leavingreasonData || []}
                icons={{
                    Add: () => <AddIcon />,
                    Edit: () => <EditIcon />,
                    Delete: () => <DeleteIcon />
                }}
                editable={{
                    onRowAdd: (newRow) =>
                        new Promise((resolve, reject) => {
                            dispatch(AddLeavingReasonAction(newRow))
                            setTimeout(() => resolve(), 500);
                        }),
                    onRowUpdate: (newRow, oldRow) =>
                        new Promise((resolve, reject) => {
                            dispatch(UpdateLeavingReasonAction(newRow))
                            setTimeout(() => resolve(), 500);
                        }),
                    onRowDelete: (selectedRow) =>
                        new Promise((resolve, reject) => {
                            dispatch(DeleteLeavingReasonAction({ leavingreason_id: `{${selectedRow?.leavingreason_id}}` }))
                            setTimeout(() => resolve(), 1000);
                        }),
                }}
                options={{
                    maxBodyHeight: 220,
                    rowStyle: { fontSize: "13px" },
                    headerStyle: { padding: "0px 10px", fontWeight: "bold" },
                    sorting: true,
                    search: false,
                    searchFieldAlignment: "right",
                    searchAutoFocus: true,
                    searchFieldVariant: "standard",
                    filtering: false,
                    paging: false,
                    selection: false,
                    actionsColumnIndex: -1,
                    grouping: false,
                    addRowPosition: "first",
                }}
                title=""
            />
        </Box>
    );
}
export default LeavingReason;